/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v2
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { HTTPValidationError } from '../model';
// @ts-ignore
import type { MfaTotpRegistration } from '../model';
// @ts-ignore
import type { MfaTotpStatus } from '../model';
// @ts-ignore
import type { MfaTotpVerification } from '../model';
/**
 * AuthApi - axios parameter creator
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Revoke local sessions identified by a validated OIDC logout token.
         * @summary Backchannel Logout
         * @param {string | null} [logoutToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        backchannelLogout: async (logoutToken?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/backchannel-logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();


            if (logoutToken !== undefined) { 
                localVarFormParams.set('logout_token', logoutToken as any);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return whether the current user has enrolled a TOTP factor in Zitadel.
         * @summary Get Totp Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotpStatus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/mfa/totp/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Start TOTP enrollment for the current user in Zitadel.
         * @summary Register Totp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerTotp: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/mfa/totp/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove the current user\'s TOTP enrollment in Zitadel.
         * @summary Remove Totp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTotp: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/mfa/totp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verify the current user\'s pending TOTP enrollment in Zitadel.
         * @summary Verify Totp
         * @param {MfaTotpVerification} mfaTotpVerification 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyTotp: async (mfaTotpVerification: MfaTotpVerification, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mfaTotpVerification' is not null or undefined
            assertParamExists('verifyTotp', 'mfaTotpVerification', mfaTotpVerification)
            const localVarPath = `/auth/mfa/totp/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mfaTotpVerification, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * Revoke local sessions identified by a validated OIDC logout token.
         * @summary Backchannel Logout
         * @param {string | null} [logoutToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async backchannelLogout(logoutToken?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.backchannelLogout(logoutToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.backchannelLogout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return whether the current user has enrolled a TOTP factor in Zitadel.
         * @summary Get Totp Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTotpStatus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MfaTotpStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTotpStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.getTotpStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Start TOTP enrollment for the current user in Zitadel.
         * @summary Register Totp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerTotp(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MfaTotpRegistration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerTotp(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.registerTotp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove the current user\'s TOTP enrollment in Zitadel.
         * @summary Remove Totp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeTotp(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MfaTotpStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeTotp(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.removeTotp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Verify the current user\'s pending TOTP enrollment in Zitadel.
         * @summary Verify Totp
         * @param {MfaTotpVerification} mfaTotpVerification 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyTotp(mfaTotpVerification: MfaTotpVerification, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MfaTotpStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyTotp(mfaTotpVerification, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.verifyTotp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthApi - factory interface
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * Revoke local sessions identified by a validated OIDC logout token.
         * @summary Backchannel Logout
         * @param {AuthApiBackchannelLogoutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        backchannelLogout(requestParameters: AuthApiBackchannelLogoutRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.backchannelLogout(requestParameters.logoutToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Return whether the current user has enrolled a TOTP factor in Zitadel.
         * @summary Get Totp Status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTotpStatus(options?: RawAxiosRequestConfig): AxiosPromise<MfaTotpStatus> {
            return localVarFp.getTotpStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * Start TOTP enrollment for the current user in Zitadel.
         * @summary Register Totp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerTotp(options?: RawAxiosRequestConfig): AxiosPromise<MfaTotpRegistration> {
            return localVarFp.registerTotp(options).then((request) => request(axios, basePath));
        },
        /**
         * Remove the current user\'s TOTP enrollment in Zitadel.
         * @summary Remove Totp
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeTotp(options?: RawAxiosRequestConfig): AxiosPromise<MfaTotpStatus> {
            return localVarFp.removeTotp(options).then((request) => request(axios, basePath));
        },
        /**
         * Verify the current user\'s pending TOTP enrollment in Zitadel.
         * @summary Verify Totp
         * @param {AuthApiVerifyTotpRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyTotp(requestParameters: AuthApiVerifyTotpRequest, options?: RawAxiosRequestConfig): AxiosPromise<MfaTotpStatus> {
            return localVarFp.verifyTotp(requestParameters.mfaTotpVerification, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for backchannelLogout operation in AuthApi.
 */
export interface AuthApiBackchannelLogoutRequest {
    readonly logoutToken?: string | null
}

/**
 * Request parameters for verifyTotp operation in AuthApi.
 */
export interface AuthApiVerifyTotpRequest {
    readonly mfaTotpVerification: MfaTotpVerification
}

/**
 * AuthApi - object-oriented interface
 */
export class AuthApi extends BaseAPI {
    /**
     * Revoke local sessions identified by a validated OIDC logout token.
     * @summary Backchannel Logout
     * @param {AuthApiBackchannelLogoutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public backchannelLogout(requestParameters: AuthApiBackchannelLogoutRequest = {}, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).backchannelLogout(requestParameters.logoutToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return whether the current user has enrolled a TOTP factor in Zitadel.
     * @summary Get Totp Status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTotpStatus(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).getTotpStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Start TOTP enrollment for the current user in Zitadel.
     * @summary Register Totp
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public registerTotp(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).registerTotp(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove the current user\'s TOTP enrollment in Zitadel.
     * @summary Remove Totp
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removeTotp(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).removeTotp(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Verify the current user\'s pending TOTP enrollment in Zitadel.
     * @summary Verify Totp
     * @param {AuthApiVerifyTotpRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public verifyTotp(requestParameters: AuthApiVerifyTotpRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).verifyTotp(requestParameters.mfaTotpVerification, options).then((request) => request(this.axios, this.basePath));
    }
}

